import { PRODUCT_CATEGORY } from '../types/category';

export function capitalize(word: string) {
  if (word !== null && word !== undefined) {
    const value = word.toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

function convertToCamelCase(wordsArr: string[]) {
  const firstWord = wordsArr[0];
  const otherWords = wordsArr.slice(1);
  const tranformedWords = [firstWord, ...otherWords.map(word => word[0]?.toUpperCase() + word.slice(1))];
  return tranformedWords.join('');
}
function convertToPascalCase(wordsArr: string[]) {
  return wordsArr.map(word => word[0]?.toUpperCase() + word.slice(1)).join('');
}
function convertToKebabCase(wordsArr: string[]) {
  return wordsArr.map(word => word[0]?.toLowerCase() + word.slice(1)).join('-');
}
function convertToSnakeCase(wordsArr: string[]) {
  return wordsArr.map(word => word[0]?.toLowerCase() + word.slice(1)).join('_');
}
function getWordsFromCamelOrPascalCase(word: string) {
  return word.split(/(?=[A-Z])/).map(word => word.toLowerCase());
}
function getWordsFromKebabCase(word: string) {
  return word.split('-').map(word => word.toLowerCase());
}
function getWordsFromSnakeCase(word: string) {
  return word.split('_').map(word => word.toLowerCase());
}
type TcaseNamingConvention = 'camel' | 'pascal' | 'kebab' | 'snake';
const wordFormerByCase = {
  camel: convertToCamelCase,
  pascal: convertToPascalCase,
  kebab: convertToKebabCase,
  snake: convertToSnakeCase
};
const wordGetterByCase = {
  camel: getWordsFromCamelOrPascalCase,
  pascal: getWordsFromCamelOrPascalCase,
  kebab: getWordsFromKebabCase,
  snake: getWordsFromSnakeCase
};
export function changeNamingConvention(
  currentName: string,
  originalCase: TcaseNamingConvention,
  newCase: TcaseNamingConvention
) {
  if (currentName.length === 0) return '';
  const getWordsFromName = wordGetterByCase[originalCase];
  const formNewName = wordFormerByCase[newCase];
  const words = getWordsFromName(currentName);
  return formNewName(words);
}

export function getCategoryName(category: PRODUCT_CATEGORY) {
  switch (category) {
    case PRODUCT_CATEGORY.LAPTOP:
      return 'Laptop';
    case PRODUCT_CATEGORY.CELLPHONES:
      return 'Celular';
    case PRODUCT_CATEGORY.MONITORS:
      return 'Monitor';
    case PRODUCT_CATEGORY.DESKS:
    case PRODUCT_CATEGORY.CHAIRS:
    case PRODUCT_CATEGORY.FURNITURE:
      return 'Mobiliario';
    case PRODUCT_CATEGORY.ACCESSORIES:
      return 'Accesorio';
    case PRODUCT_CATEGORY.PRINTERS:
      return 'Impresora';
    case PRODUCT_CATEGORY.PC:
      return 'PC';
    case PRODUCT_CATEGORY.DEP_LAPTOPS:
      return 'Laptop con DEP';
    case PRODUCT_CATEGORY.CTO_LAPTOPS:
      return 'Laptop CTO';
    default:
      return 'Herramienta';
  }
}
